export const MainPage = {
    title: 'Manage Apps',
    contentTitle: 'Manage 3rd Party Applications'
};

export const SojernTracking = {
    appName: 'Sojern Tracking'
};

export const GoogleAds = {
    appName: 'Google Ads'
};

export const BingAds = {
    appName: 'Bing Ads'
};

export const HotelsNetwork = {
    appName: 'The Hotels Network',
    consent:
        'mailto:partnershipsteam@thehotelsnetwork.com?subject=The Hotels Network Widget Implementation Request on SynXis Booking Engine&body=I would like to take up the opportunity of the Free 2 month trial period to use The Hotels Network Widget on SynXis Booking Engine.%0D%0A%0D%0APlease contact me using the following details:%0D%0A%0D%0AName:%0D%0A%0D%0AChain/Hotel Name:%0D%0A%0D%0AEmail:%0D%0A%0D%0ATel:'
};

export const Trivago = {
    appName: 'Trivago Advertiser',
    channelsList: [
        {
            key: 'tebadv',
            label: 'Express Booking Advertiser'
        },
        {
            key: 'lpadv',
            label: 'Landing Page Advertiser'
        }
    ],
    advertiserIdMaxLength: 128
};

export const Tripadvisor = {
    appName: 'Trip Advisor'
};

export const Uplift = {
    appName: 'Flexpay'
};

export const InContextBeta = {
    appName: 'In-Context Beta'
};

export const Common = {
    active: { key: 'active', label: 'ACTIVE' },
    inactive: { key: 'inactive', label: 'INACTIVE' },
    inherit: { key: 'inherit', label: 'INHERIT' }
};



// WEBPACK FOOTER //
// ./src/constants/ManageApps.js